import { useCallback, useState } from "react";
import { geocodeCoordinates } from "../../../services/googlemaps";
import log from "../logger";
import Cookies from "js-cookie";
import { startCase } from "lodash";
import useUserLocationAtom from "./use-user-location-atom";

const getGeoLocationPosition = () =>
  new Promise((resolve, reject) =>
    navigator.geolocation.getCurrentPosition(resolve, reject)
  );

const getLocationPermissions = async () => {
  return navigator.permissions.query({ name: "geolocation" }).then((result) => {
    return result.state;
  });
};

export default function useUserLocation() {
  const [getUserAddressError, setGetUserAddressError] = useState(null);
  const [isLoadingUserAddress, setIsLoadingUserAddress] = useState(false);
  const [hasCookieError, setHasCookieError] = useState(false);

  const { userLocation, setUserLocation } = useUserLocationAtom();

  const getUserAddress = useCallback(async () => {
    try {
      const permissions = await getLocationPermissions();
      if (permissions === "denied") {
        setGetUserAddressError("User denied Geolocation"); // this displays a location settings message to the user if they have previously denied permissions
      }
      if (permissions !== "denied") {
        setIsLoadingUserAddress(true);
        const { coords } = await getGeoLocationPosition();
        const address = await geocodeCoordinates(
          coords.latitude,
          coords.longitude
        );
        setIsLoadingUserAddress(false);
        setUserLocation({
          ...userLocation,
          lat: coords.latitude,
          lng: coords.longitude,
          address,
        });
      }
    } catch (e) {
      setIsLoadingUserAddress(false);
      setGetUserAddressError(e.message); // this displays a location settings message to the user if they click "Deny"
    }
  }, [userLocation]);

  const getUserCityState = useCallback(() => {
    const NO_COOKIE_ERROR = "No geolocation cookies found for BOPIS";
    try {
      const latitude = Cookies.get("lll_adobe_geo_latitude") * 1 || null;
      const longitude = Cookies.get("lll_adobe_geo_longitude") * 1 || null;
      const city = startCase(Cookies.get("lll_adobe_geo_city") || "");
      const state = startCase(Cookies.get("lll_adobe_geo_state") || "");

      if (!latitude || !longitude || !city || !state) {
        throw new Error(NO_COOKIE_ERROR);
      }

      setUserLocation({
        ...userLocation,
        lat: latitude,
        lng: longitude,
        city,
        state,
      });
    } catch (e) {
      console.log(e);
      if (e.message === NO_COOKIE_ERROR) {
        setHasCookieError(true);
        log.warn(e, {
          tags: {
            functionName: useUserLocation.name,
          },
        });
      } else {
        log.error(e, {
          tags: {
            functionName: useUserLocation.name,
          },
        });
      }
    }
  }, [userLocation]);

  return {
    getUserAddress,
    getUserAddressError,
    getUserCityState,
    hasCookieError,
    isLoadingUserAddress,
    setUserLocation,
    setGetUserAddressError,
    userLocation,
  };
}
